import React, { Fragment, useState, useEffect } from 'react';
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import RecordsTable from './recordsTable';
import { formatDate } from '../../lib/helpers';
import { Nav } from "tabler-react";

const tableHeaders = ["Traveler Photo", "Traveler Name", "Pick Up", "Destination", "Status", "Departure Date", "Created At"];
const mapResponseData = (data) => {
  if (!data)
    return []

  const getTrimmedObj = (obj) => {
    let trimmedObj = {
      ID: obj['_id'],
      imgUrl: obj.owner.photo || "/logo.png",
      userID: obj.owner.userId,
      username: obj.owner.username,
      pickup: obj.fromCity.name,
      destination: obj.toCity.name,
      state: obj.state,
      departureDate: formatDate(new Date(obj.tripDate)),
      createdAt: formatDate(new Date(obj.createdAt))
    }
    return trimmedObj;
  }

  return data.map(obj => getTrimmedObj(obj))
}

const statuses = ["Pending", "Started", "In Progress"]

const Trips = ({ openMainModal, closeMainModal, location }) => {
  const [relatedStatuses, setRelatedStatuses] = useState([])

  const getMilestone = () => {
    const paths = {
      '/trips/placed': `milestone=Placed`,
      '/trips/progress': `milestone=In Progress`,
      '/trips/completed': `milestone=Completed`,
      '/trips/rejected': `milestone=Rejected`,
    }

    return paths[location.pathname] || ''
  }
  const [reload, toggleReload] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [status, setStatus] = useState('')

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`trips?${status === statuses[1] || status === statuses[2] ? '' : `page=${page}&`}${status && `state=${status === statuses[1] ? statuses[2] : status}`}&sort=createdAt:-1&${getMilestone()}${searchParam}`, reload);
  const [filteredData, setFilteredData] = useState([])
  const [filteredCount, setFilteredCount] = useState(0)

  useEffect(() => {
    setPage(1)
  }, [location.pathname, status])

  useEffect(() => {
    if (location.pathname.includes('placed'))
      setRelatedStatuses(["", statuses[0]])
    else if (location.pathname.includes('progress'))
      setRelatedStatuses(["", statuses[1], statuses[2]])
    else if (location.pathname.includes('completed'))
      setRelatedStatuses([""])
    else if (location.pathname.includes('rejected'))
      setRelatedStatuses([""])
    setStatus("")
  }, [location.pathname])

  useEffect(() => {
    if (!loading && data) {
      if (status === statuses[1] || status === statuses[2]) {
        let tmp = null
        if (status === statuses[1])
          tmp = data.filter(obj => new Date(obj.tripDate) <= new Date())
        else
          tmp = data.filter(obj => new Date(obj.tripDate) > new Date())

        setFilteredData(tmp.slice((page - 1) * 10, Math.min(page * 10, tmp.length)))
        setFilteredCount(tmp.length)
      }
      else if (location.pathname.includes('progress')) { // All
        let tmp = data.map(e => {
          if (new Date(e.tripDate) <= new Date())
            return { ...e, state: statuses[1] }
          return e
        })

        setFilteredData(tmp)
        setFilteredCount(totalCount)
      }
      else {
        setFilteredData(data)
        setFilteredCount(totalCount)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, status, page])

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={tableHeaders}
        records={mapResponseData(filteredData)}
        closeMainModal={() => closeMainModal()}
        openMainModal={openMainModal}
        reload={() => toggleReload(r => !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      >
        <Nav>
          {relatedStatuses.map((item, i) =>
            <Nav.Item key={i}
              active={status === item} icon=""
              onClick={() => setStatus(item)}
            >
              {item || "All"}
            </Nav.Item>
          )}
        </Nav>
      </RecordsTable>
      <PaginationBar page={page} totalCount={filteredCount} setPage={setPage} />
    </Fragment>
  );
}

export default Trips;
